import { buildVizProps } from '@/utils/metricInsightAdapter'

export const REFERENCE_CHART_TYPES = ['bar', 'line']

export function formatNumber(n) {
  return typeof n === 'number' ? n.toLocaleString(undefined, { maximumFractionDigits: 2 }) : ''
}

export function supportsReference(chartType) {
  return REFERENCE_CHART_TYPES.includes(chartType || 'bar')
}

export function referenceLine(reference, summary) {
  if (!reference) return null
  if (reference.kind === 'constant') return { value: Number(reference.value || 0), label: 'target' }
  if (!summary || typeof summary.group_average !== 'number') return null
  const n = summary.average_of
  return { value: summary.group_average, label: `avg of ${n} ${n === summary.groups ? (n === 1 ? 'group' : 'groups') : 'values'}` }
}

export function sheetViz(result, reference) {
  const config = { ...(result.viz_config || {}), title: undefined }
  const line = result.viz_type === 'chart_v6' && supportsReference(result.chart_type)
    ? referenceLine(reference, result.summary) : null
  if (line) {
    config.goal = line.value
    config.goal_label = line.label
  }
  return buildVizProps(result.viz_type, config, result.rows || [])
}

export function coverageText(summary) {
  if (!summary || !summary.groups || summary.groups <= summary.shown) return ''
  return `Showing ${formatNumber(summary.shown)} of ${formatNumber(summary.groups)} groups`
}
